import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ListView from '../Common/ListView.react';
import ContactListItem from './ContactListItem';

import ContactStore from '../../stores/ContactStore';
import ContactActions from '../../actions/ContactActionCreator';

class ContactList extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            contacts: [],
            count: 0,
            page: 0,
            limit: 50,
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        ContactStore.addChangeListener(this.onChange);
        ContactActions.getAll({limit: this.state.limit});
    }

    componentWillUnmount() {
        ContactStore.removeChangeListener(this.onChange);
    }

    render() {

        const isAdmin      = this.context.auth.isAdmin();
        const newEntityUrl = isAdmin ? '/dashboard/contact/new' : '';

        return (
            <ListView
                title="Contacts"
                sortOptions={this.props.sortOptions}
                sortAction={ContactActions.getAll}
                searchAction={ContactActions.search}
                items={this.state.contacts}
                itemDecorator={ContactListItem}
                newEntityUrl={newEntityUrl}
            />
        )
    }

    onChange() {
        this.setState({contacts: ContactStore.getAll({limit: this.state.limit})});
    }
}

ContactList.defaultProps = {
    sortOptions: [
        {label: 'Name', value: 'name'},
        {label: 'First name', value: 'firstName'},
        {label: 'Last name', value: 'lastName'}
    ]
};

ContactList.contextTypes = {
    auth: PropTypes.object.isRequired
};
export default ContactList;
